import React from "react";
import { ExternalLink } from "lucide-react";

const FORM_URL = "https://docs.google.com/forms/d/e/1FAIpQLSdg7j_BIp82njKMHR9T4fHm-YStUi6GeMq_z5wVOndw5JYkIQ/viewform";
const EDUSCOPIE_LOGO = "https://customer-assets-4nw71qhi.emergentagent.net/job_ecole-pleine-nature/artifacts/8mmpdxl1_image.png";
const EDUSCOPIE_URL = "https://eduscopie.net/creer-et-gerer-une-ecole-democratique/";

export default function FormationFinancing({ t }) {
  return (
    <section className="container-page pb-24" data-testid="formation-financing">
      <h2 className="font-heading text-2xl sm:text-3xl text-ink mb-4">
        {t("formation.financing_title")}
      </h2>
      <p className="text-ink-muted leading-relaxed max-w-3xl mb-8">
        {t("formation.financing_intro")}
      </p>

      <div className="grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_18rem] gap-8 lg:gap-12 items-start">
        <div className="card-soft overflow-hidden p-2 sm:p-4">
          <iframe
            title={t("formation.financing_title")}
            src={`${FORM_URL}?embedded=true`}
            className="w-full border-0 rounded-[1.25rem] bg-cream-50 block"
            style={{ minHeight: "900px" }}
            data-testid="formation-form"
          >
            {t("common.loading")}
          </iframe>
          <p className="mt-4 mb-1 text-sm text-ink-muted text-center">
            <a
              href={FORM_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-forest hover:text-forest-dark underline underline-offset-4"
              data-testid="formation-form-fallback"
            >
              {t("formation.form_fallback")} <ExternalLink size={15} />
            </a>
          </p>
        </div>

        <aside className="lg:sticky lg:top-28">
          <p className="text-xs uppercase tracking-[0.14em] text-ink-muted mb-2">
            {t("formation.certified")}
          </p>
          <p className="text-xs text-ink-muted mb-5">
            {t("formation.hosted_by")}
          </p>
          <a
            href={EDUSCOPIE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block transition-opacity hover:opacity-80"
            data-testid="eduscopie-link"
            aria-label={t("formation.eduscopie_alt")}
          >
            <img
              src={EDUSCOPIE_LOGO}
              alt={t("formation.eduscopie_alt")}
              className="h-20 sm:h-24 w-auto object-contain"
              data-testid="eduscopie-logo"
            />
          </a>
        </aside>
      </div>
    </section>
  );
}
